import { lazy } from "react";
import { ALLOWED_MODULES } from "../../constants/enums";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { PROMOCODE_ROUTE } from "./promocode.constant";

const PromoCodeList = Loadable(
	lazy(() =>
		import("./PromoCodeList").then(({ PromoCodeList }) => ({
			default: PromoCodeList,
		}))
	)
);

const ManagePromoCode = Loadable(
	lazy(() =>
		import("./ManagePromoCode").then(({ ManagePromoCode }) => ({
			default: ManagePromoCode,
		}))
	)
);

export const promocodeRoutes = [
	{
		path: PROMOCODE_ROUTE,
		exact: true,
		element: (
			<AuthorizedRoute
				
				moduleIds={[ALLOWED_MODULES.PROMOCODE]}
			>
				<PromoCodeList />
			</AuthorizedRoute>
		),
	},
	{
		path: `${PROMOCODE_ROUTE}/manage`,
		exact: true,
		element: (
			<AuthorizedRoute
				
				moduleIds={[ALLOWED_MODULES.PROMOCODE]}
			>
				<ManagePromoCode />
			</AuthorizedRoute>
		),
	},
	{
		path: `${PROMOCODE_ROUTE}/manage/:uuid`,
		exact: true,
		element: (
			<AuthorizedRoute
				
				moduleIds={[ALLOWED_MODULES.PROMOCODE]}
			>
				<ManagePromoCode />
			</AuthorizedRoute>
		),
	},
];
